module.exports = __webpack_public_path__ + "img/affiliate-portal-walkthrough.6b389680.png";